import { createReducer } from "redux-create-reducer";

import {
  GET_WATCH_LIST_ENTRIES_HIGH_RISK_COUNTRIES,
  CLEAR_WATCH_LIST_ENTRIES_HIGH_RISK_COUNTRIES,
  DELETE_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES,
  SET_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES_SEARCH_FILTERS,
  SET_NO_ENTRIES_MESSAGE_HIGH_RISK_COUNTRIES,
} from "../types";

const initialState = {
  pageInfo: {
    count: 0,
    itemsPerPage: 10,
  },
  filters: {
    name: "",
    nationalityId: null,
  },
  isLoading: false,
  entries: [],
  noEntriesMessage: "",
};

const watchListEntriesReducer = createReducer(initialState, {
  [SET_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES_SEARCH_FILTERS]: (
    state,
    { payload }
  ) => ({
    ...initialState,
    filters: payload,
    isLoading: false,
  }),

  [GET_WATCH_LIST_ENTRIES_HIGH_RISK_COUNTRIES.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_WATCH_LIST_ENTRIES_HIGH_RISK_COUNTRIES.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_WATCH_LIST_ENTRIES_HIGH_RISK_COUNTRIES.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_WATCH_LIST_ENTRIES_HIGH_RISK_COUNTRIES.FULFILLED]: (
    state,
    { payload }
  ) => ({
    ...state,
    entries: payload.data,
    isLoading: false,
  }),

  [DELETE_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES.FULFILLED]: (state) => ({
    ...state,
  }),
  [SET_NO_ENTRIES_MESSAGE_HIGH_RISK_COUNTRIES]: (state, { payload }) => {
    return {
      ...state,
      isLoading: false,
      noEntriesMessage: payload,
    };
  },
  [CLEAR_WATCH_LIST_ENTRIES_HIGH_RISK_COUNTRIES]: () => initialState,
});

export default watchListEntriesReducer;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/reducers/watchListEntriesReducer.js